import React, { memo } from 'react';
import { Grid, Paper, Typography } from '@material-ui/core';
import SnPLogo from '../../assets/images/logos/SP_Global_logo.png';
import { FOOTER_HEIGHT } from 'config/appConfig';
import { useLocation } from 'react-router-dom';

const Footer = () => {
  const location = useLocation();
  return !['/comparision', '/watchlist', '/social-screener'].includes(location.pathname) ? (
    <Paper elevation={2} square>
      <Grid container direction="column" justify="center" alignItems="center" style={{ height: FOOTER_HEIGHT, gap: 3 }}>
        <Typography variant="caption" color="textSecondary">
          In Partnership with S&P Global
        </Typography>
        <img alt="S&P Global" src={SnPLogo} width="100" />
        <Typography variant="caption" color="textSecondary">
          © 2021 by Context Analytics, Inc All rights reserved.
        </Typography>
      </Grid>
    </Paper>
  ) : null;
};

export default memo(Footer);
